import type { CSSProperties, ReactNode } from "react";
import { ArtistIcon } from "../icons/ArtistIcon";

export interface ArtworkThumbnailProps {
	readonly src?: string;
	readonly alt?: string;
	readonly size?: number;
	readonly className?: string;
	readonly children?: ReactNode;
}

/**
 * ArtworkThumbnail — square artwork cell with a music-note fallback when no
 * source is supplied. Mirrors `DSArtworkThumbnail` on iOS.
 */
export function ArtworkThumbnail({
	src,
	alt = "",
	size = 56,
	className = "",
	children,
}: Readonly<ArtworkThumbnailProps>) {
	const style: CSSProperties = { width: `${size}px`, height: `${size}px` };
	return (
		<span className={`ds-artwork ${className}`.trim()} style={style}>
			{src === undefined ? (
				(children ?? <ArtistIcon name="music" size={Math.round(size * 0.45)} />)
			) : (
				// biome-ignore lint/performance/noImgElement: small thumbnail sized via inline style; next/image adds no value at these sizes on a static-export site
				<img src={src} alt={alt} />
			)}
		</span>
	);
}
